import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";

const FinancialYear = Cookies.get("FinancialYear");
const Firm = Cookies.get("Firm");

const DataBase = Cookies.get("Database");



// -------------------dashboard ------------------

export const FinishMeterSummery = createAsyncThunk(
    'Gray/FinishMeter',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/Gray/FinishMeter`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                AcIDs: data.AcIDs ? data.AcIDs : "",
                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : ""
            },);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const DateWiseDateWiseDtl = createAsyncThunk(
    'Report/DateWiseDateWiseDtl',

    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseDateWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDtate: data.EndDtate ? data.EndDtate : "",
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWisePartyWiseDtl = createAsyncThunk(
    'Report/DateWisePartyWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWisePartyWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWiseItemWiseDtl = createAsyncThunk(
    'Report/DateWiseItemWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseItemWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWiseGroupWiseDtl = createAsyncThunk(
    'Report/DateWiseGroupWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseGroupWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWiseBookWiseDtl = createAsyncThunk(
    'Report/DateWiseBookWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseBookWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const DateWiseDateWiseSumm = createAsyncThunk(
    'Report/DateWiseDateWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseDateWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWisePartyWiseSumm = createAsyncThunk(
    'Report/DateWisePartyWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWisePartyWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWiseItemWiseSumm = createAsyncThunk(
    'Report/DateWiseItemWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseItemWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWiseGroupWiseSumm = createAsyncThunk(
    'Report/DateWiseGroupWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseGroupWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const DateWiseBookWiseSumm = createAsyncThunk(
    'Report/DateWiseBookWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/DateWiseBookWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const BookWiseBookWiseDtl = createAsyncThunk(
    'Report/BookWiseBookWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseBookWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseDateWiseDtl = createAsyncThunk(
    'Report/BookWiseDateWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseDateWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWisePartyWiseDtl = createAsyncThunk(
    'Report/BookWisePartyWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWisePartyWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseItemWiseDtl = createAsyncThunk(
    'Report/BookWiseItemWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseItemWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseGroupWiseDtl = createAsyncThunk(
    'Report/BookWiseGroupWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseGroupWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseMonthWiseDtl = createAsyncThunk(
    'Report/BookWiseMonthWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseMonthWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const BookWiseBookWiseSumm = createAsyncThunk(
    'Report/BookWiseBookWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseBookWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseDateWiseSumm = createAsyncThunk(
    'Report/BookWiseDateWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseDateWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWisePartyWiseSumm = createAsyncThunk(
    'Report/BookWisePartyWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWisePartyWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseItemWiseSumm = createAsyncThunk(
    'Report/BookWiseItemWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseItemWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseGroupWiseSumm = createAsyncThunk(
    'Report/BookWiseGroupWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseGroupWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const BookWiseMonthWiseSumm = createAsyncThunk(
    'Report/BookWiseMonthWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/BookWiseMonthWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const PartyWisePartyWiseDtl = createAsyncThunk(
    'Report/PartyWisePartyWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWisePartyWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseDateWiseDtl = createAsyncThunk(
    'Report/PartyWiseDateWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseDateWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseItemWiseDtl = createAsyncThunk(
    'Report/PartyWiseItemWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseItemWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseGroupWiseDtl = createAsyncThunk(
    'Report/PartyWiseGroupWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseGroupWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseBookWiseDtl = createAsyncThunk(
    'Report/PartyWiseBookWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseBookWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseMonthWiseDtl = createAsyncThunk(
    'Report/PartyWiseMonthWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseMonthWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const PartyWisePartyWiseSumm = createAsyncThunk(
    'Report/PartyWisePartyWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWisePartyWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseDateWiseSumm = createAsyncThunk(
    'Report/PartyWiseDateWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseDateWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseItemWiseSumm = createAsyncThunk(
    'Report/PartyWiseItemWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseItemWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseGroupWiseSumm = createAsyncThunk(
    'Report/PartyWiseGroupWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseGroupWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseBookWiseSumm = createAsyncThunk(
    'Report/PartyWiseBookWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseBookWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const PartyWiseMonthWiseSumm = createAsyncThunk(
    'Report/PartyWiseMonthWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/PartyWiseMonthWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)




export const ItemWiseItemWiseDtl = createAsyncThunk(
    'Report/ItemWiseItemWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseItemWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseDateWiseDtl = createAsyncThunk(
    'Report/ItemWiseDateWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseDateWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWisePartyWiseDtl = createAsyncThunk(
    'Report/ItemWisePartyWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWisePartyWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseGroupWiseDtl = createAsyncThunk(
    'Report/ItemWiseGroupWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseGroupWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseBookWiseDtl = createAsyncThunk(
    'Report/ItemWiseBookWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseBookWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseMonthWiseDtl = createAsyncThunk(
    'Report/ItemWiseMonthWiseDtl',
    async (data) => {

        try {
            const response = await api.post(`/Report/ItemWiseMonthWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const ItemWiseItemWiseSumm = createAsyncThunk(
    'Report/ItemWiseItemWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseItemWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseDateWiseSumm = createAsyncThunk(
    'Report/ItemWiseDateWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseDateWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWisePartyWiseSumm = createAsyncThunk(
    'Report/ItemWisePartyWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWisePartyWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseGroupWiseSumm = createAsyncThunk(
    'Report/ItemWiseGroupWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseGroupWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseBookWiseSumm = createAsyncThunk(
    'Report/ItemWiseBookWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseBookWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const ItemWiseMonthWiseSumm = createAsyncThunk(
    'Report/ItemWiseMonthWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/ItemWiseMonthWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const GroupWiseGroupWiseDtl = createAsyncThunk(
    'Report/GroupWiseGroupWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseGroupWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseDateWiseDtl = createAsyncThunk(
    'Report/GroupWiseDateWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseDateWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWisePartyWiseDtl = createAsyncThunk(
    'Report/GroupWisePartyWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWisePartyWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseItemWiseDtl = createAsyncThunk(
    'Report/GroupWiseItemWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseItemWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseBookWiseDtl = createAsyncThunk(
    'Report/GroupWiseBookWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseBookWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseMonthWiseDtl = createAsyncThunk(
    'Report/GroupWiseMonthWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseMonthWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const GroupWiseGroupWiseSumm = createAsyncThunk(
    'Report/GroupWiseGroupWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseGroupWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseDateWiseSumm = createAsyncThunk(
    'Report/GroupWiseDateWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseDateWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWisePartyWiseSumm = createAsyncThunk(
    'Report/GroupWisePartyWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWisePartyWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseItemWiseSumm = createAsyncThunk(
    'Report/GroupWiseItemWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseItemWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseBookWiseSumm = createAsyncThunk(
    'Report/GroupWiseBookWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseBookWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const GroupWiseMonthWiseSumm = createAsyncThunk(
    'Report/GroupWiseMonthWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/GroupWiseMonthWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const MonthWiseMonthWiseDtl = createAsyncThunk(
    'Report/MonthWiseMonthWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseMonthWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWisePartyWiseDtl = createAsyncThunk(
    'Report/MonthWisePartyWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWisePartyWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseItemWiseDtl = createAsyncThunk(
    'Report/MonthWiseItemWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseItemWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseGroupWiseDtl = createAsyncThunk(
    'Report/MonthWiseGroupWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseGroupWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseBookWiseDtl = createAsyncThunk(
    'Report/MonthWiseBookWiseDtl',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseBookWiseDtl`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseMonthWiseSumm = createAsyncThunk(
    'Report/MonthWiseMonthWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseMonthWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const MonthWisePartyWiseSumm = createAsyncThunk(
    'Report/MonthWisePartyWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWisePartyWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseItemWiseSumm = createAsyncThunk(
    'Report/MonthWiseItemWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseItemWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseGroupWiseSumm = createAsyncThunk(
    'Report/MonthWiseGroupWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseGroupWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)

export const MonthWiseBookWiseSumm = createAsyncThunk(
    'Report/MonthWiseBookWiseSumm',
    async (data) => {
        try {
            const response = await api.post(`/Report/MonthWiseBookWiseSumm`, {
                FirmIDs: Firm,
                DataBase: DataBase,

                AcYearIDs: FinancialYear,
                Montyh: "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                QualityIDs: data.QualityIds ? data.QualityIds : "",
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                StartDate: data.StartDate,
                EndDtate: data.EndDtate,
            },);
            return response.data;

        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
)



export const GroupInwardReportSlice = createSlice({
    name: 'greyDashBord',
    initialState: {

        FinishMeterSummerydata: null,

        DateWiseDateWiseDtlData: null,
        DateWisePartyWiseDtlData: null,
        DateWiseItemWiseDtlData: null,
        DateWiseGroupWiseDtlData: null,
        DateWiseBookWiseDtlData: null,

        DateWiseDateWiseSummData: null,
        DateWisePartyWiseSummData: null,
        DateWiseItemWiseSummData: null,
        DateWiseGroupWiseSummData: null,
        DateWiseBookWiseSummData: null,


        BookWiseBookWiseDtlData: null,
        BookWiseDateWiseDtlData: null,
        BookWisePartyWiseDtlData: null,
        BookWiseItemWiseDtlData: null,
        BookWiseGroupWiseDtlData: null,
        BookWiseMonthWiseDtlData: null,

        BookWiseBookWiseSummData: null,
        BookWiseDateWiseSummData: null,
        BookWisePartyWiseSummData: null,
        BookWiseItemWiseSummData: null,
        BookWiseGroupWiseSummData: null,
        BookWiseMonthWiseSummData: null,

        PartyWisePartyWiseDtlData: null,
        PartyWiseDateWiseDtlData: null,
        PartyWiseItemWiseDtlData: null,
        PartyWiseGroupWiseDtlData: null,
        PartyWiseBookWiseDtlData: null,
        PartyWiseMonthWiseDtlData: null,

        PartyWisePartyWiseSummData: null,
        PartyWiseDateWiseSummData: null,
        PartyWiseItemWiseSummData: null,
        PartyWiseGroupWiseSummData: null,
        PartyWiseBookWiseSummData: null,
        PartyWiseMonthWiseSummData: null,

        ItemWiseItemWiseDtlData: null,
        ItemWiseDateWiseDtlData: null,
        ItemWisePartyWiseDtlData: null,
        ItemWiseGroupWiseDtlData: null,
        ItemWiseBookWiseDtlData: null,
        ItemWiseMonthWiseDtlData: null,

        ItemWiseItemWiseSummData: null,
        ItemWiseDateWiseSummData: null,
        ItemWisePartyWiseSummData: null,
        ItemWiseGroupWiseSummData: null,
        ItemWiseBookWiseSummData: null,
        ItemWiseMonthWiseSummData: null,

        GroupWiseGroupWiseDtlData: null,
        GroupWiseDateWiseDtlData: null,
        GroupWisePartyWiseDtlData: null,
        GroupWiseItemWiseDtlData: null,
        GroupWiseBookWiseDtlData: null,
        GroupWiseMonthWiseDtlData: null,

        GroupWiseGroupWiseSummData: null,
        GroupWiseDateWiseSummData: null,
        GroupWisePartyWiseSummData: null,
        GroupWiseItemWiseSummData: null,
        GroupWiseBookWiseSummData: null,
        GroupWiseMonthWiseSummData: null,

        MonthWiseMonthWiseDtlData: null,
        MonthWisePartyWiseDtlData: null,
        MonthWiseItemWiseDtlData: null,
        MonthWiseGroupWiseDtlData: null,
        MonthWiseBookWiseDtlData: null,

        MonthWiseMonthWiseSummData: null,
        MonthWisePartyWiseSummData: null,
        MonthWiseItemWiseSummData: null,
        MonthWiseGroupWiseSummData: null,
        MonthWiseBookWiseSummData: null,

    },
    reducers: {


        // Finish
        resetFinishMeterSummery: (state) => {
            state.FinishMeterSummerydata = null;
        },

        // ================= DATE WISE =================

        // Detail
        resetDateWiseDateWiseDetail: (state) => {
            state.DateWiseDateWiseDtlData = null;
        },
        resetDateWisePartyWiseDetail: (state) => {
            state.DateWisePartyWiseDtlData = null;
        },
        resetDateWiseItemWiseDetail: (state) => {
            state.DateWiseItemWiseDtlData = null;
        },
        resetDateWiseGroupWiseDetail: (state) => {
            state.DateWiseGroupWiseDtlData = null;
        },
        resetDateWiseBookWiseDetail: (state) => {
            state.DateWiseBookWiseDtlData = null;
        },

        // Summary
        resetDateWiseDateWiseSummary: (state) => {
            state.DateWiseDateWiseSummData = null;
        },
        resetDateWisePartyWiseSummary: (state) => {
            state.DateWisePartyWiseSummData = null;
        },
        resetDateWiseItemWiseSummary: (state) => {
            state.DateWiseItemWiseSummData = null;
        },
        resetDateWiseGroupWiseSummary: (state) => {
            state.DateWiseGroupWiseSummData = null;
        },
        resetDateWiseBookWiseSummary: (state) => {
            state.DateWiseBookWiseSummData = null;
        },

        // ================= BOOK WISE =================

        // Detail
        resetBookWiseBookWiseDetail: (state) => {
            state.BookWiseBookWiseDtlData = null;
        },
        resetBookWiseDateWiseDetail: (state) => {
            state.BookWiseDateWiseDtlData = null;
        },
        resetBookWisePartyWiseDetail: (state) => {
            state.BookWisePartyWiseDtlData = null;
        },
        resetBookWiseItemWiseDetail: (state) => {
            state.BookWiseItemWiseDtlData = null;
        },
        resetBookWiseGroupWiseDetail: (state) => {
            state.BookWiseGroupWiseDtlData = null;
        },
        resetBookWiseMonthWiseDetail: (state) => {
            state.BookWiseMonthWiseDtlData = null;
        },

        // Summary
        resetBookWiseBookWiseSummary: (state) => {
            state.BookWiseBookWiseSummData = null;
        },
        resetBookWiseDateWiseSummary: (state) => {
            state.BookWiseDateWiseSummData = null;
        },
        resetBookWisePartyWiseSummary: (state) => {
            state.BookWisePartyWiseSummData = null;
        },
        resetBookWiseItemWiseSummary: (state) => {
            state.BookWiseItemWiseSummData = null;
        },
        resetBookWiseGroupWiseSummary: (state) => {
            state.BookWiseGroupWiseSummData = null;
        },
        resetBookWiseMonthWiseSummary: (state) => {
            state.BookWiseMonthWiseSummData = null;
        },

        // ================= PARTY WISE =================

        // Detail
        resetPartyWisePartyWiseDetail: (state) => {
            state.PartyWisePartyWiseDtlData = null;
        },
        resetPartyWiseDateWiseDetail: (state) => {
            state.PartyWiseDateWiseDtlData = null;
        },
        resetPartyWiseItemWiseDetail: (state) => {
            state.PartyWiseItemWiseDtlData = null;
        },
        resetPartyWiseGroupWiseDetail: (state) => {
            state.PartyWiseGroupWiseDtlData = null;
        },
        resetPartyWiseBookWiseDetail: (state) => {
            state.PartyWiseBookWiseDtlData = null;
        },
        resetPartyWiseMonthWiseDetail: (state) => {
            state.PartyWiseMonthWiseDtlData = null;
        },

        // Summary
        resetPartyWisePartyWiseSummary: (state) => {
            state.PartyWisePartyWiseSummData = null;
        },
        resetPartyWiseDateWiseSummary: (state) => {
            state.PartyWiseDateWiseSummData = null;
        },
        resetPartyWiseItemWiseSummary: (state) => {
            state.PartyWiseItemWiseSummData = null;
        },
        resetPartyWiseGroupWiseSummary: (state) => {
            state.PartyWiseGroupWiseSummData = null;
        },
        resetPartyWiseBookWiseSummary: (state) => {
            state.PartyWiseBookWiseSummData = null;
        },
        resetPartyWiseMonthWiseSummary: (state) => {
            state.PartyWiseMonthWiseSummData = null;
        },

        // ================= ITEM WISE =================

        // Detail
        resetItemWiseItemWiseDetail: (state) => {
            state.ItemWiseItemWiseDtlData = null;
        },
        resetItemWiseDateWiseDetail: (state) => {
            state.ItemWiseDateWiseDtlData = null;
        },
        resetItemWisePartyWiseDetail: (state) => {
            state.ItemWisePartyWiseDtlData = null;
        },
        resetItemWiseGroupWiseDetail: (state) => {
            state.ItemWiseGroupWiseDtlData = null;
        },
        resetItemWiseBookWiseDetail: (state) => {
            state.ItemWiseBookWiseDtlData = null;
        },
        resetItemWiseMonthWiseDetail: (state) => {
            state.ItemWiseMonthWiseDtlData = null;
        },

        // Summary
        resetItemWiseItemWiseSummary: (state) => {
            state.ItemWiseItemWiseSummData = null;
        },
        resetItemWiseDateWiseSummary: (state) => {
            state.ItemWiseDateWiseSummData = null;
        },
        resetItemWisePartyWiseSummary: (state) => {
            state.ItemWisePartyWiseSummData = null;
        },
        resetItemWiseGroupWiseSummary: (state) => {
            state.ItemWiseGroupWiseSummData = null;
        },
        resetItemWiseBookWiseSummary: (state) => {
            state.ItemWiseBookWiseSummData = null;
        },
        resetItemWiseMonthWiseSummary: (state) => {
            state.ItemWiseMonthWiseSummData = null;
        },

        // ================= GROUP WISE =================

        // Detail
        resetGroupWiseGroupWiseDetail: (state) => {
            state.GroupWiseGroupWiseDtlData = null;
        },
        resetGroupWiseDateWiseDetail: (state) => {
            state.GroupWiseDateWiseDtlData = null;
        },
        resetGroupWisePartyWiseDetail: (state) => {
            state.GroupWisePartyWiseDtlData = null;
        },
        resetGroupWiseItemWiseDetail: (state) => {
            state.GroupWiseItemWiseDtlData = null;
        },
        resetGroupWiseBookWiseDetail: (state) => {
            state.GroupWiseBookWiseDtlData = null;
        },
        resetGroupWiseMonthWiseDetail: (state) => {
            state.GroupWiseMonthWiseDtlData = null;
        },

        // Summary
        resetGroupWiseGroupWiseSummary: (state) => {
            state.GroupWiseGroupWiseSummData = null;
        },
        resetGroupWiseDateWiseSummary: (state) => {
            state.GroupWiseDateWiseSummData = null;
        },
        resetGroupWisePartyWiseSummary: (state) => {
            state.GroupWisePartyWiseSummData = null;
        },
        resetGroupWiseItemWiseSummary: (state) => {
            state.GroupWiseItemWiseSummData = null;
        },
        resetGroupWiseBookWiseSummary: (state) => {
            state.GroupWiseBookWiseSummData = null;
        },
        resetGroupWiseMonthWiseSummary: (state) => {
            state.GroupWiseMonthWiseSummData = null;
        },

        // ================= MONTH WISE =================

        // Detail
        resetMonthWiseMonthWiseDetail: (state) => {
            state.MonthWiseMonthWiseDtlData = null;
        },
        resetMonthWisePartyWiseDetail: (state) => {
            state.MonthWisePartyWiseDtlData = null;
        },
        resetMonthWiseItemWiseDetail: (state) => {
            state.MonthWiseItemWiseDtlData = null;
        },
        resetMonthWiseGroupWiseDetail: (state) => {
            state.MonthWiseGroupWiseDtlData = null;
        },
        resetMonthWiseBookWiseDetail: (state) => {
            state.MonthWiseBookWiseDtlData = null;
        },

        // Summary
        resetMonthWiseMonthWiseSummary: (state) => {
            state.MonthWiseMonthWiseSummData = null;
        },
        resetMonthWisePartyWiseSummary: (state) => {
            state.MonthWisePartyWiseSummData = null;
        },
        resetMonthWiseItemWiseSummary: (state) => {
            state.MonthWiseItemWiseSummData = null;
        },
        resetMonthWiseGroupWiseSummary: (state) => {
            state.MonthWiseGroupWiseSummData = null;
        },
        resetMonthWiseBookWiseSummary: (state) => {
            state.MonthWiseBookWiseSummData = null;
        },

    },
    extraReducers: (builder) => {

        builder
            .addCase(FinishMeterSummery.pending, (state) => {
                state.greyDashboardLoading = true;
                state.greyDashboardError = null;
            })
            .addCase(FinishMeterSummery.fulfilled, (state, action) => {
                state.greyDashboardLoading = false;
                state.FinishMeterSummerydata = action.payload;
            })
            .addCase(FinishMeterSummery.rejected, (state, action) => {
                state.greyDashboardLoading = false;
                state.greyDashboardError = action.payload || action.error.message;
            })

            .addCase(DateWiseDateWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseDateWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseDateWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseDateWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWisePartyWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWisePartyWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWisePartyWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWisePartyWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseItemWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseItemWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseItemWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseItemWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseGroupWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseGroupWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseGroupWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseGroupWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseBookWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseBookWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseBookWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseBookWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseDateWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseDateWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseDateWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseDateWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWisePartyWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWisePartyWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWisePartyWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWisePartyWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseItemWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseGroupWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseGroupWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseGroupWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseGroupWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(DateWiseBookWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DateWiseBookWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.DateWiseBookWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(DateWiseBookWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(BookWiseBookWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseBookWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseBookWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseBookWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseDateWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseDateWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseDateWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseDateWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWisePartyWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWisePartyWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWisePartyWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWisePartyWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseItemWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseItemWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseItemWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseItemWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseGroupWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseGroupWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseGroupWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseGroupWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseMonthWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseMonthWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseMonthWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseMonthWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseBookWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseBookWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseBookWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseBookWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseDateWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseDateWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseDateWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseDateWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWisePartyWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWisePartyWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWisePartyWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWisePartyWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseItemWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseGroupWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseGroupWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseGroupWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseGroupWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(BookWiseMonthWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(BookWiseMonthWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.BookWiseMonthWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(BookWiseMonthWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWisePartyWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWisePartyWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWisePartyWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWisePartyWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseDateWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseDateWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseDateWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseDateWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseItemWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseItemWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseItemWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseItemWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseGroupWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseGroupWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseGroupWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseGroupWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseBookWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseBookWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseBookWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseBookWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseMonthWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseMonthWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseMonthWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseMonthWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWisePartyWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWisePartyWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWisePartyWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWisePartyWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseDateWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseDateWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseDateWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseDateWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseItemWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseGroupWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseGroupWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseGroupWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseGroupWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseBookWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseBookWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseBookWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseBookWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyWiseMonthWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyWiseMonthWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyWiseMonthWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(PartyWiseMonthWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseItemWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseItemWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseItemWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseItemWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseDateWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseDateWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseDateWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseDateWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWisePartyWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWisePartyWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWisePartyWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWisePartyWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseGroupWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseGroupWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseGroupWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseGroupWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseBookWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseBookWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseBookWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseBookWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseMonthWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseMonthWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseMonthWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseMonthWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseItemWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseDateWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseDateWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseDateWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseDateWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWisePartyWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWisePartyWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWisePartyWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWisePartyWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseGroupWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseGroupWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseGroupWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseGroupWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseBookWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseBookWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseBookWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseBookWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemWiseMonthWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseMonthWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseMonthWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(ItemWiseMonthWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseGroupWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseGroupWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseGroupWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseGroupWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseDateWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseDateWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseDateWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseDateWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWisePartyWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWisePartyWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWisePartyWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWisePartyWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseItemWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseItemWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseItemWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseItemWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseBookWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseBookWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseBookWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseBookWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseMonthWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseMonthWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseMonthWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseMonthWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseGroupWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseGroupWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseGroupWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseGroupWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseDateWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseDateWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseDateWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseDateWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWisePartyWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWisePartyWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWisePartyWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWisePartyWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseItemWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseBookWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseBookWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseBookWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseBookWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(GroupWiseMonthWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(GroupWiseMonthWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.GroupWiseMonthWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(GroupWiseMonthWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseMonthWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseMonthWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseMonthWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseMonthWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWisePartyWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWisePartyWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWisePartyWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWisePartyWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseItemWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseItemWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseItemWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseItemWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseGroupWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseGroupWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseGroupWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseGroupWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseBookWiseDtl.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseBookWiseDtl.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseBookWiseDtlData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseBookWiseDtl.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseMonthWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseMonthWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseMonthWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseMonthWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWisePartyWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWisePartyWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWisePartyWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWisePartyWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseItemWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseGroupWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseGroupWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseGroupWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseGroupWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MonthWiseBookWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MonthWiseBookWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MonthWiseBookWiseSummData = action.payload; // Update the state with fetched data
            })
            .addCase(MonthWiseBookWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

    },
});

export default GroupInwardReportSlice.reducer;
export const {
    resetFinishMeterSummery,

    // DATE WISE
    resetDateWiseDateWiseDetail,
    resetDateWisePartyWiseDetail,
    resetDateWiseItemWiseDetail,
    resetDateWiseGroupWiseDetail,
    resetDateWiseBookWiseDetail,

    resetDateWiseDateWiseSummary,
    resetDateWisePartyWiseSummary,
    resetDateWiseItemWiseSummary,
    resetDateWiseGroupWiseSummary,
    resetDateWiseBookWiseSummary,

    // BOOK WISE
    resetBookWiseBookWiseDetail,
    resetBookWiseDateWiseDetail,
    resetBookWisePartyWiseDetail,
    resetBookWiseItemWiseDetail,
    resetBookWiseGroupWiseDetail,
    resetBookWiseMonthWiseDetail,

    resetBookWiseBookWiseSummary,
    resetBookWiseDateWiseSummary,
    resetBookWisePartyWiseSummary,
    resetBookWiseItemWiseSummary,
    resetBookWiseGroupWiseSummary,
    resetBookWiseMonthWiseSummary,

    // PARTY WISE
    resetPartyWisePartyWiseDetail,
    resetPartyWiseDateWiseDetail,
    resetPartyWiseItemWiseDetail,
    resetPartyWiseGroupWiseDetail,
    resetPartyWiseBookWiseDetail,
    resetPartyWiseMonthWiseDetail,

    resetPartyWisePartyWiseSummary,
    resetPartyWiseDateWiseSummary,
    resetPartyWiseItemWiseSummary,
    resetPartyWiseGroupWiseSummary,
    resetPartyWiseBookWiseSummary,
    resetPartyWiseMonthWiseSummary,

    // ITEM WISE
    resetItemWiseItemWiseDetail,
    resetItemWiseDateWiseDetail,
    resetItemWisePartyWiseDetail,
    resetItemWiseGroupWiseDetail,
    resetItemWiseBookWiseDetail,
    resetItemWiseMonthWiseDetail,

    resetItemWiseItemWiseSummary,
    resetItemWiseDateWiseSummary,
    resetItemWisePartyWiseSummary,
    resetItemWiseGroupWiseSummary,
    resetItemWiseBookWiseSummary,
    resetItemWiseMonthWiseSummary,

    // GROUP WISE
    resetGroupWiseGroupWiseDetail,
    resetGroupWiseDateWiseDetail,
    resetGroupWisePartyWiseDetail,
    resetGroupWiseItemWiseDetail,
    resetGroupWiseBookWiseDetail,
    resetGroupWiseMonthWiseDetail,

    resetGroupWiseGroupWiseSummary,
    resetGroupWiseDateWiseSummary,
    resetGroupWisePartyWiseSummary,
    resetGroupWiseItemWiseSummary,
    resetGroupWiseBookWiseSummary,
    resetGroupWiseMonthWiseSummary,

    // MONTH WISE
    resetMonthWiseMonthWiseDetail,
    resetMonthWisePartyWiseDetail,
    resetMonthWiseItemWiseDetail,
    resetMonthWiseGroupWiseDetail,
    resetMonthWiseBookWiseDetail,

    resetMonthWiseMonthWiseSummary,
    resetMonthWisePartyWiseSummary,
    resetMonthWiseItemWiseSummary,
    resetMonthWiseGroupWiseSummary,
    resetMonthWiseBookWiseSummary,

} = GroupInwardReportSlice.actions;